import React from 'react'
import { Element, Form } from 'react-bulma-components'

interface ConfirmDeleteInputProps {
  value: string
  expectedValue: string
  onChange: (value: string) => void
  label?: string
  placeholder?: string
  name?: string
}

/**
 * Composant réutilisable pour la confirmation de suppression par recopie
 * Affiche un champ de saisie où l'utilisateur doit recopier une valeur exacte pour confirmer
 */
const ConfirmDeleteInput: React.FC<ConfirmDeleteInputProps> = ({
  value,
  expectedValue,
  onChange,
  label,
  placeholder,
  name,
}) => {
  const isValid = value === expectedValue

  return (
    <Element mt={4}>
      <Form.Field>
        <Form.Label>
          {label || (
            <>
              Pour confirmer, veuillez saisir <strong>{expectedValue}</strong>
            </>
          )}
        </Form.Label>
        <Form.Control>
          <Form.Input
            value={value}
            name={name || 'confirm-delete'}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder || `Saisir "${expectedValue}"`}
            color={value ? (isValid ? 'success' : 'danger') : undefined}
            style={{ color: 'black' }}
          />
        </Form.Control>
      </Form.Field>
    </Element>
  )
}

export default ConfirmDeleteInput
